import React from "react";
import CellInput from "../../global/CellInput";
import func, { translateLabel } from "../../../services/functions";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const moment = require("moment");
const generatePaymentsReceiptColumns = (
    {
        t,
        i18n,
        handleThermalPrint
    }
        = {}) => {
    // let columns = queueColumns != null ? queueColumns.split(",") : null;


    const currencyOptions = [
        { value: "ALL", label: "Lek" },
        { value: "EUR", label: "Euro"},
        { value: "USD", label: "USD" },
    ];

    const statusOptions = [

        {
            label: (t("openBanking.receivedStatus")),
            value:"RECEIVED"
        },
        {
            label: (t("openBanking.reportedStatus")),
            value:"REPORTED"
        },

    ]

    return [

        {
            header: t(["home.status"]),
            field: "paymentStatus",
            style: { minWidth: "220px", maxWidth: "220px" },
            filter: true,
            persisted: true,
            mobile: { priority: 1, isBadge: true, group: "status" },
            filterType: "DROPDOWN",
            filterConfig: {
                options: statusOptions,
                optionValue: "value",
                optionLabel: "label",
            },
        },

//         {
//             header: t(["invoice.print"]),
//             field: 'print',
//             style: { minWidth: "150px", maxWidth: "300px" },
//             body: invoice => (
//                 <div className='d-flex align-items-center'>

//                     {invoice.iic &&
//                         <a
//                             href="#"
//                             className={"nav-link p-0 d-flex-align-items-center "}
//                             onClick={(e) => { e.preventDefault(); handleThermalPrint(invoice.id) }}>
//                             <img src="https://profisc.al/wp-content/uploads/2021/10/kupon.svg" title={t('invoice.printThermal')}  width="38" height="32" className="mr-1" />
//                         </a>}

// {/* */}

//                 </div>
//             ),
//             persisted:true
//         },
       
        {
            header: t("openBanking.buyer/sender"),
            field: "buyerName",
            style: { minWidth: "220px", maxWidth: "300px" },
            filter: true,
            persisted: true,
            default:true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },

        {
            header: t("openBanking.reconciliation"),
            field: "reconciliation",
            style: { minWidth: "150px", maxWidth: "150px" },
            persisted: true,
            default:true,
            mobile: { priority: 2 },
        },
        {
            header: t(["table.buyerNIPT"]),
            field: "buyerNipt",
            style: { minWidth: "150px", maxWidth: "300px" },
            filter: true,
            persisted: true,
            default:true,
            mobile: { priority: 1, group: "identity" },
        },

        // {
        //     field: "issueDate",
        //     header: t(["table.issueDatetime"]),
        //     body: (receipt) =>receipt?.issueDate ? moment(receipt?.issueDate).format("DD/MM/YYYY HH:mm"):"",
        //     style: { minWidth: 200, maxWidth: 300 },
        //     filter: true,
        //     filterType: "DATE",
        //     filterConfig: {
        //         like: false,
                
        //     },
        //     persisted: true,
        //     formattedExportValue: true,
        //     preventExcelFormat: true,
        //     sortable: true,

        // },

//   {
//             field: "dueDate",
//             header: t(("invoice.paymentDate")),
//             body: (receipt) =>receipt?.dueDate ? moment(receipt?.dueDate).format("DD/MM/YYYY HH:mm"):"",
//             style: { minWidth: 220, maxWidth: 300 },
//             filter: true,
//             filterType: "DATE",
//             filterConfig: {
//                 like: false
//             },
//             persisted: true,
//             formattedExportValue: true,
//             preventExcelFormat: true,
//             sortable: true,

//         },
        {
            header: t(["invoice.transactionId"]),
            filter: true,
            style: { minWidth: 200, maxWidth: 300 },
            field: "transactionId",
            persisted: true,
            default: true,
            mobile: { priority: 1, group: "identity" },
        },

        {
            header: t(["invoice.currency"]),
            field: "currency",
            default: true,
            persisted: true,
            sortable:true,
            style: { minWidth: "150px", maxWidth: "300px" },
            body: (receipt) => receipt.currency,
            filter: true,
            filterType:"MULTISELECT",
            filterConfig:{
                options: currencyOptions
            },
            mobile: { priority: 2 },
        },

        {
            header: t(['stat.total']),
            field: "amount",
            format :  (invoice) => func.getFormattedMoneyValue(invoice?.amount),
            style: { minWidth: "180px", maxWidth: "300px" },
            sortable: true,
            persisted: true,
            default: true,
            sortable:true,
            mobile: { priority: 1, group: "financial" },
        },

        {
            header:  t(["common.source"]),
            filter: true,
            field: "source",
            style: { minWidth: "180px", maxWidth: "300px" },
            persisted: true,
            default: true,
            sortable:true,
            mobile: { priority: 2 },
        },
          {
            field: "paymentType",
            header: t(["books.paymentType"]),
            style: { minWidth: 150, maxWidth: 180 },
            mobile: { priority: 2 },
          },

        {
            header: t(['home.paymentMethodType']),
            style: { minWidth: "230px", maxWidth: "300px" },
            field: 'paymentMethod',
            mobile: { priority: 3 },
        },
        {
            field: "reportedDate",
            header: t(['invoice.reportedDate']),
            body: (receipt) =>receipt?.reportedDate ? moment(receipt?.reportedDate).format("DD/MM/YYYY HH:mm"):"",
            style: { minWidth: 200, maxWidth: 300 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,
            mobile: { priority: 1, group: "dates" },

        },
        {
            field: "recordDate",
            header: t(['invoice.paymentDateTime']),
            body: (receipt) =>receipt?.recordDate ? moment(receipt?.recordDate).format("DD/MM/YYYY HH:mm"):"",
            style: { minWidth: 200, maxWidth: 300 },
            filter: true,
            filterType: "DATE",
            filterConfig: {
                like: false
            },
            persisted: true,
            formattedExportValue: true,
            preventExcelFormat: true,
            sortable: true,
            mobile: { priority: 1, group: "dates" },

        },
    ];
};

export default generatePaymentsReceiptColumns;
